import axios from "axios";

export default axios.create({
  baseURL: "https://productionwaiterfill.scheduler.smartqr.app/api/",
});
